export default {
  data_management_desk: '基础数据',
  member_management_desk: '会员运营',
  campaign_management_desk: '营销管理',
  member_recruitment: '会员招募',
  cdp_management_desk: '数据中台',
  sms_management_desk: '短信管理',
  email_management_desk: '邮件管理',
  mall_management_desk: '商城管理',
  member_tools_desk: '会员工具'
}
